import UZod from "@repo/utils/UZod";
import Bookable from "./Bookable.js";

type Recurrence = {
  id: Recurrence.Id;
  rrule: string;
  duration: number;
} & Omit<Bookable, "endAt" | "id">;

namespace Recurrence {
  export type Id = `r_${string}`;
  export namespace Id {
    export const is = (id: string): id is Id => id.startsWith("r_");
    export const zodSchema = (message = "Invalid recurrence id.") =>
      UZod.predicate(is, message);
  }
  export type Params = Omit<Bookable.Params, "endAt"> & {
    rrule: string;
    duration: number;
  };
}

export default Recurrence;
